import { useMemo } from 'react';

import AnalyticsResponseRollupCollection from 'components/insights/query/AnalyticsResponseRollupCollection';
import DataTable from 'components/shared/DataTable';
import { useNetworkPerformanceActions, useNetworkPerformanceStore } from 'stores/networkPerformanceStore';

import {
  buildProviderPerformanceColumns,
  buildProviderPerformanceRows,
  PROVIDER_DEFAULT_SORT,
} from './providerPerformanceColumns';

type Props = {
  loading: boolean;
  rollups: AnalyticsResponseRollupCollection;
};

export default function ProviderPerformanceTable({ loading, rollups }: Props) {
  const selectedGroupType = useNetworkPerformanceStore((state) => state.selectedGroupType);
  const { openEntitySlideout } = useNetworkPerformanceActions();

  const entityHeader = `${selectedGroupType?.displayName ?? ''} Company`.trim();
  const columns = useMemo(
    () => buildProviderPerformanceColumns(entityHeader, openEntitySlideout),
    [entityHeader, openEntitySlideout]
  );
  const data = useMemo(() => buildProviderPerformanceRows(rollups), [rollups]);

  return (
    <DataTable
      columns={columns}
      data={data}
      loading={loading}
      freezeFirstColumn
      hasFooter={false}
      defaultSortBy={[PROVIDER_DEFAULT_SORT]}
    />
  );
}
